import axios from "axios";
import axiosLexaApi from "./axiosLexaApi";
import { Cookies } from "react-cookie";
import {
  isLexaUpstreamResponse,
  lexaProxyHeaders,
  lexaProxyUrl,
  withCorpAuth,
} from "./lexaProxyAuth";

const cookies = new Cookies();

// Authorization carries the corporate token for the proxy (withCorpAuth);
// the Lexa token travels in X-Lexa-Authorization and is forwarded upstream.
const axiosLexaApiPrivate = withCorpAuth(
  axios.create({
    baseURL: lexaProxyUrl,
    headers: lexaProxyHeaders,
    withCredentials: true,
  })
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, accessToken = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(accessToken);
    }
  });

  failedQueue = [];
};

axiosLexaApiPrivate.interceptors.request.use(
  (config) => {
    const accessToken = cookies.get("lexaAccessToken"); // Retrieve access token from cookies
    if (accessToken) {
      config.headers["X-Lexa-Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosLexaApiPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      isLexaUpstreamResponse(error.response) &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((accessToken) => {
            originalRequest.headers["X-Lexa-Authorization"] = "Bearer " + accessToken;
            return axiosLexaApiPrivate(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        axiosLexaApi
          .post("/RefreshJWTToken")
          .then((response) => {
            return response.data;
          })
          .then((data) => {
            const newAccessToken = data;
            cookies.set("lexaAccessToken", newAccessToken, {
              secure: true,
              path: "/",
              sameSite: "none",
            }); // Update access token in cookies
            originalRequest.headers["X-Lexa-Authorization"] =
              "Bearer " + newAccessToken;
            processQueue(null, newAccessToken);
            resolve(axiosLexaApiPrivate(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export default axiosLexaApiPrivate;
